import { APPLICATION_STAGE } from "../models/enums/applicationStage";

export const Zar = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
});

// const stageLabelMap: Record<number, string> = Object.entries(APPLICATION_STAGE)
//   .reduce((acc, [key, value]) => {
//     if (typeof value === 'number') {
//       acc[value] = key.replace(/([A-Z])/g, ' $1').trim(); 
//     }
//     return acc;
//   }, {} as Record<number, string>);

export const getApplicationStageName = (value: number): string => {
    const stageMap: Record<number, string> = {
      0: "Personal Details",
      1: "Address Details",
      2: "Institution Details",
      3: "Study Details",
      4: "Legal Guardian Details",
      5: "Documents Upload",
      6: "Application Submitted",
      9: "Application In Review",
      10: "Application Declined",
      11: "Application Sent For Further Review",
      12: "Application Fully Assessed And Is Pending University Selection",
      13: "Application Successful",
      14: "Incomplete Application",
    };
    return stageMap[value] || `Unknown Stage (${value})`;
  };